// extracted by mini-css-extract-plugin
export default {"invalidLinkBlock":"invalidlink_invalidLinkBlock__mURty","buttonsBlock":"invalidlink_buttonsBlock__ZUteP","button":"invalidlink_button__8Z9-s"};